export const fileToBase64 = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()

    reader.onload = () => {
      const result = typeof reader.result === 'string' ? reader.result : ''
      resolve(result.split(',').pop() || '')
    }

    reader.onerror = () => {
      reject(reader.error || new Error('Nao foi possivel ler o arquivo'))
    }

    reader.readAsDataURL(file)
  })

export default fileToBase64
